import { PlatformInfo } from 'src/app/util/platfrom.info'

export const environment = {
  production: true,
  name: require('../../package.json').name,
  applicationId: require('../../package.json').id,
  version: require('../../package.json').version,
  applicationName: require('../../package.json').applicationName,
  versionCode: require('../../package.json').versionCode,
  proxyApiUrl: window.location.origin,
  placeholder: 'assets/images/placeholder.png',
  platformInfo: {
    'X-Operating-System': new PlatformInfo().detectOSName(),
    'X-Platform': new PlatformInfo().detectBrowserName(),
    'X-Version': require('../../package.json').version.toString(),
    'X-Build-Number': require('../../package.json').versionCode.toString(),
    'X-Platform-Version': new PlatformInfo().detectPlatformVersion(),
  },
  defaultChannel: 'NECOM',
  payment: {
    receiverName: 'JiniFix Store',
    approvalRefNo: 'JINIFIX-',
  },
  google: {
    apiKey: 'AIzaSyDoyGl6oqpuuWg4jszu6jRRjxZJVUVeDZo',
    analyticsKey: null
  },
};
